import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import usePost from '../../Hooks/usePost';
import UpdatePaymentModal from './UpdatePaymentModal';
import AddPaymentMethodModal from './AddPaymentMethodModal';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import propTypes from 'prop-types';
import useRequest from '../../Hooks/useRequest';
import { StyledButton } from '../Generics.styled';
import CircularProgress from '@mui/material/CircularProgress';
import amexIcon from '../../Assets/amexIcon.png';
import visaIcon from '../../Assets/visaIcon.png';
import mastercardIcon from '../../Assets/mastercardIcon.png';

const PaymentMethodContainer = styled.div`
    margin-top: 30px;
    border: 1px solid lightgray;
    display: flex;
    height: ${(props) => (props.price ? '550px' : '250px')};
    max-width: 1200px;
    width: 100%;
    flex-direction: column;
    border-radius: 12px;
    padding: 16px;
    background-color: #fafbf7;
    position: relative;
`;

const Title = styled.div`
    font-size: 23px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    height: 50px;
    flex-direction: column;
    font-weight: bold;
`;

const PaymentMethodSection = styled.div`
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: space-evenly;

    @media only screen and (max-width: 620px) {
        flex-direction: column;
    }
`;

const StyledPaymentMethodApplet = styled.div`
    display: flex;
    height: 75px;
    width: 350px;
    border: 1px solid lightgray;
    border-radius: 6px;
    padding: 12px;
    background-color: white;
    cursor: pointer;

    :hover {
        background-color: #eaeaea;
    }
`;

const AddPaymentButton = styled.div`
    padding: 16px;
    font-size: 24px;
    font-weight: bold;
`;

const Brand = styled.div`
    font-size: 23px;
    width: 80px;
    text-overflow: ellipsis;
    text-align: center;
    padding: 8px;
`;
const BrandIcon = styled.img`
    object-fit: contain;
    height: 40px;
    border: 1px solid lightgray;
    border-radius: 6px;
`;

const BrandContainer = styled.div`
    display: flex;
    width: 80px;
    justify-content: center;
    align-items: center;
    overflow: hidden;
`;

const DetailsContainer = styled.div`
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    width: 200px;
    border-radius: 6px;
`;

const ActionsContainer = styled.div`
    margin-left: 10px;
    display: flex;
    width: 80px;
    border-radius: 6px;
`;

const CardSection = styled.div`
    color: black;
    font-weight: bold;
`;
const ExpSection = styled.div`
    color: gray;
    font-size: 14px;
`;

const DefaultIcon = styled.div`
    display: flex;
    padding: 2px;
    border: 1px solid black;
    height: 20px;
    width: 100%;
    color: white;
    border-radius: 6px;
    background-color: black;
    justify-content: center;
    align-items: center;
    font-size: 14px;
`;

const ShoppingCartSection = styled.div`
    display: flex;
    flex-direction: row;
    height: 200px;
    border: 1px solid lightgray;
    border-radius: 6px;
    padding: 12px;
    background-color: white;
    margin-bottom: 20px;
`;

const ItemDetailsSection = styled.div`
    display: flex;
    flex-direction: column;
    border-right: 1px solid lightgray;
    width: 50%;
    padding-right: 12px;
`;
const PriceDetailsSection = styled.div`
    display: flex;
    flex-direction: column;
    width: 50%;
    padding-left: 12px;
`;

const Checkout = ({ currentAdvertiser, onCheckout, price, itemName, itemDescription, taxPercent, afterCheckout }) => {
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [isDefaultPaymentMethod, setIsDefaultPaymentMethod] = useState({
        isDefault: false,
        methodId: '',
    });

    const [selectedMethod, setSelectedMethod] = useState({ methodId: '', index: '' });
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [addPaymentModalIsOpen, setAddPaymentModalIsOpen] = useState(false);
    const [expirationData, setExpirationData] = useState({
        expirationYear: '',
        expirationMonth: '',
    });

    const defaultPostData = {
        error: false,
        success: false,
        isLoading: false,
        message: [''],
        type: '',
    };
    const [postData, setPostData] = useState(defaultPostData);
    const elements = useElements();
    const stripe = useStripe();

    const shouldCalculateTax = taxPercent && price ? true : false;
    const total = shouldCalculateTax ? price + (taxPercent / 100) * price : price;
    const totalPriceInCents = Math.round(total * 100);

    const { post: postGetPaymentMethods } = usePost('/stripe/getPaymentMethods');
    const { post: postUpdatePaymentMethod } = usePost(`/stripe/updatePaymentMethod/${selectedMethod.methodId}`);
    const { post: postDeletePaymentMethod } = usePost(`/stripe/deletePaymentMethod/${selectedMethod.methodId}`);
    const { post: postCreateSetupIntent } = usePost(`/stripe/createSetupIntent`);
    const { post: postUpdateCustomer } = usePost('/stripe/updateCustomer');
    const { post: postCreatePaymentIntent } = usePost('/stripe/createPaymentIntent');

    const { stripeCustomerId, chargeCreditCard } = { ...currentAdvertiser };

    console.log(stripeCustomerId, chargeCreditCard, 'stripe');
    const { data, mutate } = useRequest(`/stripe/getCustomer/${stripeCustomerId}`);

    const defaultPaymentMethodId = data?.invoice_settings?.default_payment_method;

    const disablePurchaseButton =
        currentAdvertiser === null || defaultPaymentMethodId === undefined || paymentMethods?.length < 1 || !totalPriceInCents || !stripeCustomerId;

    const getPaymentMethodsByCustomerId = async () => {
        try {
            const methodsResp = await postGetPaymentMethods({ type: 'card', customerId: stripeCustomerId }, 'POST');
            const { data } = methodsResp.data;
            setPaymentMethods(data);
        } catch (err) {}
    };

    const updatePaymentMethod = async () => {
        try {
            setPostData({ error: false, success: false, isLoading: true, type: 'update' });

            const updatePaymentMethodResp = await postUpdatePaymentMethod(
                {
                    card: {
                        exp_month: expirationData.expirationMonth,
                        exp_year: expirationData.expirationYear,
                    },
                },
                'POST'
            );

            const updateCustomerResp = await postUpdateCustomer(
                {
                    invoice_settings: {
                        default_payment_method: isDefaultPaymentMethod.isDefault ? isDefaultPaymentMethod.methodId : defaultPaymentMethodId,
                    },
                },
                'POST',
                stripeCustomerId
            );

            mutate();
            const { id: updatedCustomerId } = updateCustomerResp.data;

            if (updatePaymentMethodResp.data.success === false) {
                setPostData({
                    error: true,
                    success: false,
                    isLoading: false,
                    message: ['Update Failed, please use a date in the future.'],
                });
            } else if (!updatedCustomerId) {
                setPostData({
                    error: true,
                    success: false,
                    isLoading: false,
                    message: ['Update Failed, could not save default payment method.'],
                });
            } else {
                setPostData({
                    error: false,
                    success: true,
                    isLoading: false,
                    message: ['Updated Successfully'],
                });
                setModalIsOpen(false);
            }
        } catch (err) {
            setPostData({
                error: true,
                success: false,
                isLoading: false,
                message: ['Something went wrong, Please try again later.'],
            });
        }
    };

    const handleDelete = async () => {
        try {
            setPostData({ error: false, success: false, isLoading: true, type: 'delete' });
            if (paymentMethods?.length < 4 && defaultPaymentMethodId === selectedMethod.methodId) {
                setPostData({
                    error: true,
                    success: false,
                    isLoading: false,
                    message: ['Delete Failed, must have at least 1 default payment method.'],
                });
            } else if (paymentMethods?.length < 2) {
                setPostData({
                    error: true,
                    success: false,
                    isLoading: false,
                    message: ['Delete Failed, must have at least 1 valid payment method.'],
                });
            } else {
                await postDeletePaymentMethod(null, 'POST');
                setPostData({ error: false, success: true, isLoading: false });
                setModalIsOpen(false);
            }
        } catch (err) {
            setPostData({
                error: true,
                success: false,
                isLoading: false,
                message: ['Delete Failed, please try again.'],
            });
        }
    };

    const createPaymentMethod = async () => {
        try {
            setPostData({
                error: false,
                success: false,
                isLoading: true,
                message: [''],
                type: 'create',
            });
            const { paymentMethod } = await stripe.createPaymentMethod({
                type: 'card',
                card: elements.getElement(CardElement),
            });

            const { id: paymentMethodId } = paymentMethod;

            if (paymentMethodId) {
                //attach payment methodID to setup Intent

                await postCreateSetupIntent(
                    {
                        confirm: true,
                        customerId: stripeCustomerId,
                        description: 'Create setup intent for davie',
                        paymentMethodId,
                    },
                    'POST'
                );

                setPostData({
                    error: false,
                    success: true,
                    isLoading: false,
                    message: [''],
                });
                setAddPaymentModalIsOpen(false);
            }
        } catch (err) {
            setPostData({
                error: true,
                success: false,
                isLoading: false,
                message: ['Error Creating Payment Method, please try again.'],
            });
        }
    };
    const handleCheckboxChange = () => {
        setIsDefaultPaymentMethod({
            isDefault: true,
            methodId: selectedMethod?.methodId,
        });
    };

    useEffect(() => {
        getPaymentMethodsByCustomerId();

        if (selectedMethod.methodId === defaultPaymentMethodId) {
            setIsDefaultPaymentMethod({ isDefault: true, methodId: defaultPaymentMethodId });
        } else {
            setIsDefaultPaymentMethod({ isDefault: false, methodId: selectedMethod?.methodId });
        }
    }, [modalIsOpen, addPaymentModalIsOpen, stripeCustomerId]);

    const renderBrandIcon = (brand) => {
        if (brand === 'amex') {
            return <BrandIcon src={amexIcon} alt={brand} />;
        } else if (brand === 'mastercard') {
            return <BrandIcon src={mastercardIcon} alt={brand} />;
        } else if (brand === 'visa') {
            return <BrandIcon src={visaIcon} alt={brand} />;
        } else return brand?.toUpperCase();
    };

    const PaymentMethodApplet = (method, idx) => {
        const { card } = method;
        const onSelectMethod = () => {
            setExpirationData({
                expirationMonth: card.exp_month.toString(),
                expirationYear: card.exp_year.toString(),
            });
            setPostData(defaultPostData);
            setSelectedMethod({ methodId: method.id, index: idx });
            setModalIsOpen(true);
        };
        console.log(card.brand, 'brand');
        return (
            <StyledPaymentMethodApplet onClick={() => onSelectMethod()}>
                <BrandContainer>
                    {' '}
                    <Brand>{renderBrandIcon(card?.brand)}</Brand>
                </BrandContainer>
                <DetailsContainer>
                    {' '}
                    <CardSection>
                        {card?.brand?.charAt(0).toUpperCase()}
                        {card?.brand?.slice(1)} ending in {card.last4}
                    </CardSection>
                    <ExpSection>
                        Exp date. {card.exp_month}/{card.exp_year}
                    </ExpSection>
                </DetailsContainer>
                {method.id === defaultPaymentMethodId ? (
                    <ActionsContainer>
                        <DefaultIcon>Default</DefaultIcon>
                    </ActionsContainer>
                ) : null}
            </StyledPaymentMethodApplet>
        );
    };

    const handleCheckout = async () => {
        try {
            setPostData({ isLoading: true });
            // create payment inten

            if (chargeCreditCard === true) {
                const methodsResp = await postCreatePaymentIntent(
                    {
                        customerId: stripeCustomerId,
                        amount: totalPriceInCents,
                        currency: 'usd',
                        payment_method_types: ['card'],
                        paymentMethodId: defaultPaymentMethodId,
                    },
                    'POST'
                );

                const paymentIntentId = methodsResp.data.id;

                if (paymentIntentId) {
                    const resp = await onCheckout(paymentIntentId);

                    if (resp?.data === true) {
                        console.log(resp, 'response');
                        //was successfull
                        setPostData({ ...defaultPostData, isLoading: false, success: true });
                        afterCheckout();
                    } else {
                        setPostData({
                            ...defaultPostData,
                            isLoading: false,
                            success: false,
                            type: 'checkout',
                            error: true,
                            message: ['Something went wrong. Please try again.'],
                        });
                    }
                }
            } else {
                //dont charge credit card
                const resp = await onCheckout();
                if (resp?.data === true) {
                    //was successfull
                    setPostData({ ...defaultPostData, isLoading: false, success: true });
                    afterCheckout();
                } else {
                    setPostData({
                        ...defaultPostData,
                        isLoading: false,
                        success: false,
                        type: 'checkout',
                        error: true,
                        message: ['Something went wrong. Please try again.'],
                    });
                }
            }
        } catch (err) {
            console.log(err, 'error');
            setPostData({
                ...defaultPostData,
                isLoading: false,
                success: false,
                type: 'checkout',
                error: true,
                message: ['Something went wrong. Please try again.'],
            });
        }
    };

    return (
        <PaymentMethodContainer price={price}>
            {price ? (
                <div>
                    <Title>Order Summary</Title>

                    <ShoppingCartSection>
                        <ItemDetailsSection>
                            <div>
                                <span style={{ fontWeight: 'bold' }}>Name:</span> {itemName}
                            </div>
                            <div>
                                {' '}
                                <span style={{ fontWeight: 'bold' }}>Description:</span> {itemDescription}
                            </div>
                            <div>
                                {' '}
                                <span style={{ fontWeight: 'bold' }}>Quantity:</span> 1
                            </div>
                            <div>
                                {' '}
                                <span style={{ fontWeight: 'bold' }}>Price:</span> ${price}
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 'auto' }}>
                                <span style={{ fontWeight: 'bold' }}>Subtotal:</span>
                                <div>${price}</div>
                            </div>
                        </ItemDetailsSection>
                        <PriceDetailsSection>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div>1 x {itemName}</div>
                                <div>${price}</div>
                            </div>
                            {shouldCalculateTax ? (
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div>Sales Tax</div>
                                    <div>{taxPercent}%</div>
                                </div>
                            ) : null}

                            <div
                                style={{
                                    fontSize: '24px',
                                    fontWeight: 'bold',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    marginTop: 'auto',
                                }}
                            >
                                <div>Total</div>
                                <div>${total.toFixed(2)}</div>
                            </div>
                        </PriceDetailsSection>
                    </ShoppingCartSection>
                </div>
            ) : null}

            <Title>Update Your Default Payment Method</Title>
            <PaymentMethodSection>
                {paymentMethods?.map((method, idx) => (
                    <div key={idx}>{PaymentMethodApplet(method, idx)}</div>
                ))}
                {paymentMethods?.length < 3 ? (
                    <StyledPaymentMethodApplet onClick={() => setAddPaymentModalIsOpen(true)}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <AddPaymentButton>Add a Payment Method +</AddPaymentButton>
                        </div>
                    </StyledPaymentMethodApplet>
                ) : null}
            </PaymentMethodSection>

            <div style={{ position: 'absolute', bottom: '30px', width: '85%', color: 'red', textAlign: 'right' }}>
                {postData.type === 'checkout' && postData.error ? postData.message[0] : null}
            </div>
            <div style={{ position: 'absolute', bottom: '50px', width: '85%', color: 'black', textAlign: 'right', fontWeight: 'bold' }}>
                {chargeCreditCard === false ? <div>This advertiser is on a free plan, you will not be charged.</div> : null}
            </div>

            <div>
                {price ? (
                    <StyledButton
                        disabled={disablePurchaseButton}
                        onClick={() => handleCheckout()}
                        style={{ position: 'absolute', bottom: '30px', right: '10px' }}
                    >
                        {postData.isLoading ? (
                            <CircularProgress style={{ height: '20px', width: '20px', color: 'white' }} color="primary" />
                        ) : (
                            'Checkout'
                        )}
                    </StyledButton>
                ) : null}
            </div>

            <UpdatePaymentModal
                modalIsOpen={modalIsOpen}
                setModalIsOpen={setModalIsOpen}
                selectedMethod={selectedMethod}
                updatePaymentMethod={updatePaymentMethod}
                handleDelete={handleDelete}
                postData={postData}
                expirationData={expirationData}
                setExpirationData={setExpirationData}
                isDefaultPaymentMethod={isDefaultPaymentMethod}
                handleCheckboxChange={handleCheckboxChange}
            />

            <AddPaymentMethodModal
                addPaymentModalIsOpen={addPaymentModalIsOpen}
                setAddPaymentModalIsOpen={setAddPaymentModalIsOpen}
                createPaymentMethod={createPaymentMethod}
                postData={postData}
            />
        </PaymentMethodContainer>
    );
};

Checkout.propTypes = {
    currentAdvertiser: propTypes.shape({}).isRequired,
    onCheckout: propTypes.func,
    price: propTypes.number,
    itemName: propTypes.string,
    itemDescription: propTypes.string,
    taxPercent: propTypes.number,
    afterCheckout: propTypes.func,
};

export default Checkout;
